export default __webpack_public_path__ + "apply1230d40b.png";